import React, { ReactNode } from 'react'
import { MagentoAvailablePaymentMethod as AvailablePaymentMethod } from 'lib/types'
import { PaymentOption } from './styled'

interface Props {
  method: AvailablePaymentMethod
  onChange: (method: AvailablePaymentMethod) => any
  isSelected: boolean
  children: ReactNode
}

export const Option = ({
  method,
  onChange,
  isSelected,
  children
}: Props) => {
  return (
    <PaymentOption>
      <label>
        <input
          checked={isSelected}
          name='payment_method'
          type='radio'
          onChange={() => onChange(method)}
        />
        <span>
          {children}
        </span>
      </label>
    </PaymentOption>
  )
}
